<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <a-button type="default" slot="extra" @click="handleBack">返回</a-button>
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol" :wrapper-col="wrapperCol">

                <a-form-model-item label="KA环境编码">
                    <span>{{record.kadesc + ' - ' + record.kaenv}}</span>
                </a-form-model-item>

                <a-form-model-item label="域名" ref="before" prop="before">
                    <a-input style="width:300px;" v-if="is_vue_task" v-model="record.before" :addon-after="record.after"></a-input>
                    <span v-else>{{record.domain}}</span>
                </a-form-model-item>

                <a-form-model-item ref="target" label="类型" prop="target">
                    <a-select v-if="is_vue_task" v-model="record.target" style="width: 180px">
                        <a-select-option value="qt">前台网关域名 </a-select-option>
                        <a-select-option value="zt">中台网关域名</a-select-option>
                        <a-select-option value="jt">基础网关域名</a-select-option>
                    </a-select>
                    <span v-else>{{targetNames[record.target]}}</span>
                </a-form-model-item>

                <a-form-model-item label="描述" ref="desc" prop="desc">
                    <a-input v-if="is_vue_task" v-model="record.desc"></a-input>
                    <span v-else>{{record.desc}}</span>
                </a-form-model-item>

                <a-form-model-item v-if="!is_vue_task" label="状态">
                    <span>{{statusNames[record.status]}}</span>
                </a-form-model-item>

                <a-form-model-item v-if="!is_vue_task" label="创建时间">
                    <span>{{record.createtime}}</span>
                </a-form-model-item>

                <a-form-model-item v-show="is_vue_task" :wrapper-col="{ span: 14, offset: 8 }">
                    <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>

        </a-card>
    </div>

</template>
<script>
const m_title = {
    addDomain: '新增域名',
    editDomain: '编辑域名',
    detailDomain: '域名详情',
}
const statusNames = {
    0: '未下发',
    1: '下发中',
    2: '下发失败',
    3: '下发成功',
    4: '销毁中',
    5: '销毁失败',
    6: '销毁成功',
}
const targetNames = {
    qt: '前台网关域名',
    zt: '中台网关域名',
    jt: '基础网关域名',
}
export default {
    data() {
        return {
            c_title: '',
            is_vue_task: true,
            is_new: false,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            targetNames,
            statusNames,
            rules: {
                before: [
                    { required: true, message: ' 请填写域名', trigger: 'blur' },
                ],
                target: [
                    {
                        required: true,
                        message: ' 请选择目标类型',
                        trigger: 'blur',
                    },
                ],
            },
            confirmLoading: false,
            formItemLayout: 'horizontal',
            record: {
                kadesc: '',
                kaenv: '',
                domain: '', //域名
                before: '',
                after: '',
                target: '', //目标类型
                desc: '', //描述
            },
        }
    },
    computed: {},
    components: {},
    methods: {
        handleBack() {
            this.$router.push({
                path: 'domain',
                query: {
                    kaenv: this.record.kaenv,
                },
            })
        },
        handleOk() {
            let that = this
            that.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    that.confirmLoading = true
                    const { params } = that.$route
                    that.record.domain = that.record.before + that.record.after
                    if (params.action == 'editDomain') {
                        // that.$store
                        //     .dispatch({
                        //         type: "kamanager/editDomain",
                        //         params: {
                        //             ...that.record,
                        //             operateuser:this.G.getCurrentUser().username,
                        //             urlparams: false,
                        //         }
                        //     })
                        //     .then((response) => {
                        //         if(response.data.success == '1'){
                        //             that.handleCancel();
                        //             that.confirmLoading = false;
                        //         }
                        //     });
                    } else if (params.action == 'addDomain') {
                        that.record.id = ''
                        //新增
                        that.$store
                            .dispatch({
                                type: 'kamanager/addDomain',
                                params: {
                                    ...that.record,
                                    createuser:
                                        this.G.getCurrentUser().username,
                                    urlparams: false,
                                },
                            })
                            .then((response) => {
                                if (response.data.success == '1') {
                                    that.handleCancel()
                                }
                            })
                    }
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        handleCancel() {
            this.resetForm()

            this.$router.back(-1)
        },
        resetForm() {
            this.$refs.ruleForm.resetFields()
        },

        getDetail(query) {
            let that = this
            that.$store
                .dispatch({
                    type: 'kamanager/queryDomain',
                    params: {
                        id: query.id,
                    },
                    showMsg: false,
                })
                .then((res) => {
                    if (res.status == 200 && res.data.success == '1') {
                        let result = res.data.data
                        result.before = result.domain.split('.')[0]
                        let index = result.domain.indexOf('.')
                        result.after = result.domain.slice(index)
                        that.record = {
                            ...result,
                        }
                        this.record.kadesc = query.kadesc
                    }
                })
        },
    },

    mounted() {
        const { query, params } = this.$route
        this.c_title = m_title[params.action]
        this.is_new = params.action == 'addDomain'
        this.is_vue_task = params.action != 'detailDomain'
        //初始化值
        this.record.kaenv = query.kaenv
        this.record.after = query.kaenv + '.cnzhonglunnet.com'
        this.record.kadesc = query.kadesc
        this.record.id = query.id
        if (!this.is_new) {
            this.getDetail(query)
        } else {
            this.resetForm()
        }
    },
}
</script>

<style scoped>
.ant-form-inline .ant-form-item {
    margin-right: 40px;
}
</style>
